import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="flex items-center justify-center px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-md w-full text-center">
          <div className="mb-8">
            <i className="ri-error-warning-line text-6xl text-gray-400"></i>
          </div>
          <h1 className="text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            404
          </h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/"
            className="inline-flex items-center bg-gray-900 text-white px-8 py-3 rounded-sm font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-line mr-2"></i>
            Back to Home
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}
